import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { onMounted, ref, watch } from 'vue';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import '~/assets/css/swiper.css';
import { useElementHover, useMousePressed } from '@vueuse/core';
import { useSwiperAutoplayProgress } from '@/composables';
import isTouchDevice from '~/helpers/isTouchDevice';
import { type CategoryBannerData } from '~/components/CategoryBannerLarge.vue';

interface Props {
  data: CategoryBannerData[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'MainSlider',
  props: {
    data: { default: () => [
    {
      title: 'Default title',
      description: 'Default description',
      color: 'gray',
      image: '/img/power-banks.png',
    },
  ] }
  },
  setup(__props: any) {



const swiper = ref();
const swiperContainer = ref();
const isHovered = useElementHover(swiperContainer);
const { pressed } = useMousePressed({ target: swiperContainer });
const pagination = ref();
const { progress } = useSwiperAutoplayProgress(swiper);
const { $gsap } = useContext();
const duration = 0.8;
const ease = 'power1.out';
const rotation = 0;
const space = 50;
const animateStart = () => {
  $gsap.fromTo(
    '.swiper-slide-active .image',
    { y: space, rotation, duration, ease, opacity: 0 },
    {
      y: 0,
      rotation: 0,
      duration,
      ease,
      opacity: 1,
    },
  );
  $gsap.fromTo(
    '.swiper-slide-active .image-box',
    { y: -space, duration, opacity: 0 },
    {
      y: 0,
      duration,
      opacity: 1,
    },
  );
};

const animateEnd = () => {
  $gsap.fromTo(
    '.swiper-slide-next .image-box',
    { y: 0, duration, opacity: 1 },
    {
      y: -space,
      duration,
      opacity: 0,
    },
  );
  $gsap.fromTo(
    '.swiper-slide-prev .image-box',
    { y: 0, duration, opacity: 1 },
    {
      y: -space,
      duration,
      opacity: 0,
    },
  );
  $gsap.fromTo(
    '.swiper-slide-next .image',
    { y: 0, rotation: 0, duration, ease, opacity: 1 },
    {
      y: space,
      rotation: -rotation,
      duration,
      ease,
      opacity: 0,
    },
  );
  $gsap.fromTo(
    '.swiper-slide-prev .image',
    { y: 0, rotation: 0, duration, ease, opacity: 1 },
    {
      y: space,
      rotation: -rotation,
      duration,
      ease,
      opacity: 0,
    },
  );
};

watch(progress, (newValue) => {
  const bulletActive = pagination.value.querySelector(
    '.swiper-pagination-bullet-active',
  );
  if (!bulletActive) return;
  pagination.value.querySelector(
    '.swiper-pagination-bullet-active',
  ).style.background = `linear-gradient(90deg, #ffffff ${newValue}%, rgba(255,255,255,0.2) 0%)`;
});

onMounted(() => {
  animateEnd();
});

const swiperAutoplayToggle = (state) => {
  if (state) {
    swiper.value?.$swiper.autoplay.stop();
  } else {
    swiper.value?.$swiper.autoplay.start();
  }
};

watch(isHovered, (newValue) => {
  if (isTouchDevice()) return;
  swiperAutoplayToggle(newValue);
});

watch(pressed, (newValue) => {
  if (!isTouchDevice()) return;
  swiperAutoplayToggle(newValue);
});

const swiperOptions = {
  speed: duration * 1000,
  effect: 'fade',
  loop: true,
  autoplay: {
    delay: 4000,
    disableOnInteraction: false,
    waitForTransition: false,
  },
  pagination: {
    el: '.swiper-pagination',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  on: {
    activeIndexChange: () => {
      pagination.value
        ?.querySelectorAll('.swiper-pagination-bullet')
        .forEach((el) => {
          // eslint-disable-next-line no-param-reassign
          el.style.background = '#ffffff';
        });
    },
    slideChangeTransitionEnd: () => {
      animateEnd();
      animateStart();
    },
  },
};

return { __sfc: true,swiper, swiperContainer, isHovered, pressed, pagination, progress, $gsap, duration, ease, rotation, space, animateStart, animateEnd, swiperAutoplayToggle, swiperOptions, Swiper, SwiperSlide }
}

})